import PropTypes from 'prop-types';
import React from 'react';
import Tooltip from 'react-simple-tooltip';
import { NEGATIVE_MIN, POSITIVE_MIN } from './dashboardConstants';

function DashboardTooltip({ id, label, tooltipText, position, value }) {
  const isValid = value > POSITIVE_MIN || value < NEGATIVE_MIN;
  const tooltipLabel = (
    <div className="tooltip-label" id={id}>
      {label}
    </div>
  );

  return (
    <div className="dashboard-tooltip">
      {isValid ? (
        <Tooltip
          content={tooltipText}
          placement={position}
          arrow={8}
          background="#f7efd8"
          border="#f7efd8"
          color="#000"
          fontSize="11px"
          padding={5}
          radius={5}
        >
          {tooltipLabel}
        </Tooltip>
      ) : (
        tooltipLabel
      )}
    </div>
  );
}

DashboardTooltip.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  tooltipText: PropTypes.string.isRequired,
  position: PropTypes.string,
  value: PropTypes.number.isRequired,
};

DashboardTooltip.defaultProps = {
  position: 'bottom',
};

export default React.memo(DashboardTooltip);
